import { getFeature } from 'Cloud/Application/FeaturesEs6';

interface FirebaseConfig {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
}

interface WebpushConfig {
    enablePromoTooltip: boolean;
    enableBlockedTooltip: boolean;
    platforms: {
        touch: boolean;
        pwa: boolean;
        desktop: boolean;
    };
    users: {
        b2c: boolean;
        biz: boolean;
        b2b: boolean;
    };
    multiacc: boolean;
    firebaseConfig: FirebaseConfig;
    vapidKeys: {
        pushme: string;
        fcm: string;
    };
    provider: 'fcm' | 'pushme';
    notifyRequestConfig: {
        intervalAfterCloseDays: number;
        intervalAfterSnoozeDays: number;
        showLimit: number;
        closeLimit: number;
    };
    content: {
        text: string;
        primaryButtonText: string;
        secondaryButtonText: string;
    };
}

const defaultConfig: WebpushConfig = {
    enablePromoTooltip: false,
    enableBlockedTooltip: false,
    platforms: {
        touch: false,
        pwa: false,
        desktop: false,
    },
    users: {
        b2c: false,
        biz: false,
        b2b: false,
    },
    multiacc: false,
    firebaseConfig: {
        apiKey: 'apiKey',
        authDomain: 'cloud-mail-ru.firebaseapp.com',
        databaseURL: 'https://cloud-mail-ru.firebaseio.com',
        projectId: 'cloud-mail-ru',
        storageBucket: 'cloud-mail-ru.appspot.com',
        messagingSenderId: 'messagingSenderId',
        appId: 'appId',
    },
    vapidKeys: {
        pushme: 'pushmeVapidKey',
        fcm: 'fcmVapidKey',
    },
    provider: 'fcm',
    notifyRequestConfig: {
        intervalAfterCloseDays: 2,
        intervalAfterSnoozeDays: 0.5,
        showLimit: 20,
        closeLimit: 10,
    },
    content: {
        text: 'Включите уведомления об акциях и новых функциях Облака в браузере',
        primaryButtonText: 'Включить',
        secondaryButtonText: 'Не сейчас',
    },
};

export const webpushConfig: WebpushConfig = getFeature('webpush-config') || defaultConfig;

export const webpushDebug = !!getFeature('webpush-debug');
